import { Button } from "@/components/ui/button"
import { ReactElement } from "react";
import { useI18n } from "src/i18n/I18nContext";

export interface CancelButtonProps {
    caption?: string;
    onClick: () => void;
    [key: string]: any;
}

const CancelButton = (props: CancelButtonProps): ReactElement => {
    const { caption, onClick, ...rest } = props;
    const { t } = useI18n();

    return (<Button
        colorPalette='gray'
        variant='outline'
        onClick={(e) => {
            e.preventDefault();
            onClick();
        }}
        {...rest}
    >{caption ?? t('common.cancel')}</Button>)
}

export default CancelButton
